
import { defineComponent } from "vue";

interface Feature {
  title: string;
  url: string;
  source?: string;
}

export default defineComponent({
  name: "MainRelease",
  data() {
    return {
      // Add interviews, podcasts, articles etc. here.
      // { title: "Episode / article name", source: "Show or site name", url: "https://..." }
      features: [
        {
          title: "Interview with Bad Toad Games",
          source: "A Pint of Cthulhu",
          url: "https://open.spotify.com/episode/6tahXgQZZ0wF5ciSffQTja",
        },
        {
          title: "In-depth Interview with Bad Toad Games",
          source: "Everae Games",
          url: "https://youtu.be/iASHfyt4NJc",
        },
        {
          title: "Talking in the Library, Episode 2",
          source: "Lost Lore Scholar",
          url: "https://youtu.be/WX_qeGe__iI",
        },
        {
          title: "Episode 2 - The Bad Toads",
          source: "Vindicast",
          url: "https://open.spotify.com/episode/4Ucd0hdtRAPh1rExZh69pR",
        },
        {
          title: "Interview with Jeremy Lowe & Casey Lowe",
          source: "Mildra The Monk",
          url: "https://youtu.be/5CfvxzF2r4A",
        },
      ] as Feature[],
    };
  },
});
